import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    holidayInfo: {
      Days: "",
      DaysLeft: "",
      DaysUsed: "",
      DaysPlanned: ""
    }
  },
  mutations: {
    setHolidayInfo(state, holidayInfo) {
      state.holidayInfo = holidayInfo;
    }
  },
  actions: {
    getHolidayInfo({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/absences/getHolidayInfo/${userId}`,
            method: "GET"
          })
          .then((resp) => {
            commit("setHolidayInfo", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPublicHolidaysForYear({ commit }, year) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/holidays/getHolidaysForYear/${year}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPublicHolidays({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/holidays/getHolidays`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addNewHolidays({ commit }, newHoliday) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/holidays/addHolidays/`,
            method: "POST",
            data: newHoliday
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  module: {},
  getters: {
    holidayInfo: (state) => state.holidayInfo
  }
};
